if (!customElements.get("quantity-control")) {
  class QuantityControl extends HTMLElement {
    constructor() {
      super();
      this.changeEvent = new Event("change", { bubbles: true });
    }

    connectedCallback() {
      if (this._initialized) return; // prevent double-init
      this._initialized = true;

      this.input = this.querySelector("input");
      if (!this.input) return;

      this.input.addEventListener("change", this.onInputChange.bind(this));

      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );

      this.validateQtyRules();
    }

    onButtonClick(event) {
      event.preventDefault();

      const button = event.currentTarget;
      const previousValue = this.input.value;

      if (button.name === "plus") {
        this.input.stepUp();
      } else if (button.name === "minus") {
        this.input.stepDown();
      }

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }

      this.validateQtyRules();
    }

    onInputChange() {
      this.validateQtyRules();

      const detail = {
        key: this.input.dataset.key,
        quantity: parseInt(this.input.value, 10),
      };

      this.dispatchEvent(
        new CustomEvent("quantity:change", { detail, bubbles: true })
      );
    }

    validateQtyRules() {
      const value = parseInt(this.input.value, 10);
      const min = parseInt(this.input.min || 0, 10);

      const maxAttr = this.input.getAttribute("max");
      const max = maxAttr !== null ? parseInt(maxAttr, 10) : Infinity;

      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) {
        buttonMinus.classList.toggle("disabled", value <= min);
      }

      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) {
        buttonPlus.classList.toggle("disabled", value >= max);
      }
    }

    async updateShopifyCart() {
      const quantity = parseInt(this.input.value, 10);
      const key = this.input.dataset.key;

      if (!key) {
        console.error("Missing data-key on quantity input");
        return;
      }

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
          }),
        });

        if (!response.ok) {
          throw new Error(`Shopify cart update failed (${response.status})`);
        }

        const cart = await response.json();
        console.log("Cart updated!", cart);
        // Optional: trigger a re-render, refresh, or custom event here
      } catch (error) {
        console.error("Cart update error:", error);
      }
    }
  }
  customElements.define("quantity-control", QuantityControl);
  window.QuantityControl = QuantityControl;
}

if (!customElements.get("remove-item-button")) {
  class RemoveItemButton extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", this.removeItem.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.removeItem);
    }

    async removeItem(event) {
      event.preventDefault();
      const key = this.dataset.key;
      this.classList.add("btn-delete-item--loading");

      if (!key) {
        console.error("Missing data-key on <remove-item-button>");
        return;
      }

      try {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });

        // Let global handler refresh cart
        this.dispatchEvent(
          new CustomEvent("cart:change", { bubbles: true, composed: true })
        );
        this.classList.remove("btn-delete-item--loading");
      } catch (err) {
        console.error("Error removing item from cart:", err);
        this.classList.remove("btn-delete-item--loading");
      }
    }
  }

  customElements.define("remove-item-button", RemoveItemButton);
  window.RemoveItemButton = RemoveItemButton;
}
